import styled from 'styled-components';
import { Flex } from 'onefaceui-react-components';

export const Container = styled.div`
  position: absolute;
  background: #fff;
  padding: 8px;
  z-index: 999999;
  width: 423px;
  filter: drop-shadow(0px 0px 8px #00000029);
  border: 1px solid var(--grey-300);

  .icon-status {
    width: 18px;
    height: 14px;
  }

  .icon-delivery {
    width: 18px;
    height: 18px;
  }
`;

export const TableHeader = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 155px repeat(2, 1fr);
  background: var(--grey-100);

  > span {
    padding: 2px 6px;
    &:first-child {
      text-align: right;
      background: var(--grey-300);
    }
  }

  &.col-4 {
    grid-template-columns: 155px repeat(3, 1fr);
  }
`;

export const TableItem = styled.div`
  display: grid;
  grid-template-columns: 155px repeat(2, 1fr);

  > :is(span, div) {
    border-bottom: 1px solid var(--grey-200);
    background: var(--grey-100);
    padding: 2px 6px;

    &:first-child {
      text-align: right;
      border-bottom-color: var(--grey-100);
      text-transform: capitalize;
    }

    & + :is(span, div) {
      background: none;
    }
  }

  &.col-2 {
    span + :is(span, div) {
      grid-column: 2 / span 2;
    }
  }

  &.col-4 {
    grid-template-columns: 155px repeat(3, 1fr);
  }
`;

export const ArrowContainer = styled.span`
  position: absolute;

  svg {
    fill: #fff;
    path {
      stroke: var(--grey-300);
      stroke-width: 2;
      stroke-linecap: square;
      stroke-linejoin: miter;
      stroke-dasharray: none;
      stroke-opacity: 1;
    }
  }

  &.side-top {
    bottom: -12px;
    &.align-center {
      transform: translateX(calc((423px / 2) - 10px)) rotate(180deg);
    }
    &.align-right {
      transform: translateX(-8px) rotate(180deg);
    }
    &.align-left {
      transform: translateX(calc(423px - 14px)) rotate(180deg);
    }
  }

  &.side-bottom {
    top: -12px;
    &.align-center {
      transform: translateX(calc((423px / 2) - 10px));
    }
    &.align-right {
      transform: translateX(-8px);
    }
    &.align-left {
      transform: translateX(calc(423px - 14px));
    }
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0px 5px;
  border-radius: 10px;
  height: 17px;
  background: var(--grey-300);

  &.canceled {
    background: #000000cc;
  }

  &:is(.onTime,.onTimeOffDay,.early,.earlyOffDay,.late,.lateOffDay,.noTimeWindow) {
    background: var(--success);
  }
`;

export const StopHoverTitle = styled(Flex)`
  width: 100%;
`;
